import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[t4Inject]',
    standalone: false
})
export class InjectComponentDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
